<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      item-key="acceso_obra_id"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :expand="expand"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr @click="detalles_acceso(props)">
          <td class="text-xs-left px-2">
            {{ props.item.constructora }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.estado }}
          </td>
          <td class="text-xs-left px-2">
            {{ formatter_date(props.item.vigente_desde) }}
          </td>
          <td class="text-xs-left px-2">
            {{ formatter_date(props.item.vigente_hasta) }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.empresa }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.obrero }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.obras }}
          </td>
          <td class="text-xs-left px-4">
            {{ props.item.observaciones }}
          </td>
          <td class="text-xs-left px-1">
            {{ props.item.placas }}
          </td>
          <td class="text-xs-center pl-1 pr-2">
            {{ props.item.ultimo_movimiento }}
          </td>
          <td class="text-xs-center pl-1 pr-2">
            {{ props.item.eliminado }}
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card>
          <v-card-title class="headline">Detalle Acceso Obra</v-card-title>
              <v-card-text>
                <span>
                  <strong>FECHA DE VIGENCIA</strong>:&nbsp;
                  {{ formatter_date_range(props.item.vigente_desde, props.item.vigente_hasta) }}
                  <br>
                  <strong>DÍAS PERMITIDOS</strong>: <br>
                  <span>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_lunes==true">
                      Lunes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_martes==true">
                      Martes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_miercoles==true">
                      Miércoles
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_jueves==true">
                      Jueves
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_viernes==true">
                      Viernes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_sabado==true">
                      Sábado
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.acceso_domingo==true">
                      Domingo
                    </v-chip>
                  </span>
                  <br>
                </span>
              </v-card-text>
        </v-card>
        <v-timeline>
          <v-timeline-item
            v-for="n in props.item.detalles"
            :key="n.detalle_acceso_obra_id"
            color="red lighten-2"
            small
          >
            <v-card>
              <v-card-title class="headline">{{n.fecha}}</v-card-title>
              <v-card-text>
                <strong>PORTICO</strong>: {{n.portico.toUpperCase()}}
                <br>
                <strong>ESTATUS</strong>: {{n.acceso.toUpperCase()}}
                <br>
                <strong>OBSERVACIONES</strong>: {{n.observaciones}}
                <br>
                <v-btn flat icon @click="show_acceso_detalles(props.item, n)">
                  <v-icon>description</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDetalles"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          TIPO:&nbsp;ACCESO&nbsp;OBRA
          <v-spacer></v-spacer>
          <v-btn flat icon
                 @click="close_dialog_detalles()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <template>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  :value="formatter_date(acceso.vigente_desde)"
                  label="Vigente Desde"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  :value="formatter_date(acceso.vigente_hasta)"
                  label="Vigente Hasta"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  :value="acceso.constructora"
                  label="Constructora"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  :value="acceso.empresa"
                  label="Empresa"
                  readonly
                />
              </v-flex>
            </template>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="detalle_acceso.fecha"
                label="Fecha de Movimiento"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="detalle_acceso.portico"
                label="Portico"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="detalle_acceso.acceso"
                label="Estatus"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md6>
              <v-text-field
                v-model="detalle_acceso.observaciones"
                label="Observaciones"
                readonly
              />
            </v-flex>
          </v-layout>
          <template
            v-if="detalle_acceso.personas &&
                          detalle_acceso.personas.length > 0">
            <v-layout row wrap
                      v-for="(visitante, index) in detalle_acceso.personas"
                      :key="visitante.persona_detalle_acceso_obra_id">
              <v-flex xs12 sm12 md12>
                <strong>
                  Datos Personales del Obrero No. {{ index + 1 }}
                </strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.nombres"
                  label="Nombre(s)"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.apellidos"
                  label="Apellidos"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_rostro!==''">
                <img v-if="visitante.foto_rostro != null"
                   :src="computed_image(visitante.foto_rostro)"
                   style="width: 95%"
                   alt="foto_rostro"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_frente!==''">
                <img v-if="visitante.foto_credencial_frente != null"
                   :src="computed_image(visitante.foto_credencial_frente)"
                   style="width: 95%"
                   alt="foto_credencial_frente"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_trasera!==''">
                <img v-if="visitante.foto_credencial_trasera != null"
                   :src="computed_image(visitante.foto_credencial_trasera)"
                   style="width: 95%"
                   alt="foto_credencial_trasera"/>
              </v-flex>
            </v-layout>
          </template>
          <template v-show="detalle_acceso.vehiculos">
            <template v-for="(vehiculo, index) in detalle_acceso.vehiculos">
              <v-layout row wrap :key="vehiculo.vehiculo_detalle_acceso_obra_id">
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>Datos del Vehículo No. {{ index + 1 }}</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.placa"
                    label="Placas"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.color"
                    label="Color"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.marca"
                    label="Marca"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.modelo"
                    label="Modelo"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_frontal!==''">
                  <img v-if="vehiculo.foto_frontal != null"
                       :src="computed_image(vehiculo.foto_frontal)"
                       style="width: 95%"
                       alt="foto_frontal"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_lateral!==''">
                  <img v-if="vehiculo.foto_lateral != null"
                       :src="computed_image(vehiculo.foto_lateral)"
                       style="width: 95%"
                       alt="foto_lateral"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_trasera!==''">
                  <img v-if="vehiculo.foto_trasera != null"
                       :src="computed_image(vehiculo.foto_trasera)"
                       style="width: 95%"
                       alt="foto_trasera"/>
                </v-flex>
              </v-layout>
            </template>
          </template>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';

export default {
  data: () => ({
    dialogDetalles: false,
    timer: '',
    presearch: '',
    searchTimer: null,
    expand: false,
    loading: true,
    totalItems: 0,
    rowItems: [],
    search: '',
    pagination: {},
    acceso: [],
    detalle_acceso: [],
    fetched_images: [],
    headers: [
      {
        text: 'Constructora', value: 'constructora', sortable: true, width: '10%', class: 'px-2',
      },
      {
        text: 'Estado', value: 'estado', sortable: true, width: '10%', class: 'px-2',
      },
      {
        text: 'Vigente Desde', value: 'vigente_desde', sortable: true, width: '10%', class: 'px-2',
      },
      {
        text: 'Vigente Hasta', value: 'vigente_hasta', sortable: true, width: '10%', class: 'px-2',
      },
      {
        text: 'Empresa', value: 'empresa', sortable: true, width: '10%', class: 'px-2',
      },
      {
        text: 'Obrero', value: 'obrero', sortable: false, width: '10%', class: 'px-2',
      },
      {
        text: 'Obras', value: 'obras', sortable: false, width: '50px', class: 'px-2',
      },
      {
        text: 'Observaciones', value: 'observaciones', sortable: true, width: '10%', class: 'px-4',
      },
      {
        text: 'Placas', value: 'placas', sortable: false, width: '10%', class: 'px-1',
      },
      {
        text: 'Último Evento', value: 'ultimo_movimiento', sortable: false, width: '10%', class: 'pl-1 pr-2',
      },
      {
        text: 'Eliminado', value: 'eliminado', sortable: true, width: '10%', class: 'px-2',
      },
    ],
  }),
  computed: {
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
          .then((data) => {
            this.rowItems = data.items;
            this.totalItems = data.total;
          });
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
        .then((data) => {
          this.rowItems = data.items;
          this.totalItems = data.total;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  created() {
  },
  methods: {
    computed_image(imageName) {
      if (imageName in this.fetched_images) {
        if (this.fetched_images[imageName].loaded) {
          return this.fetched_images[imageName].data;
        }
      }
      return '';
    },
    decode_base64(encoded) {
      const base = 'data:image/jpeg;base64, ';
      if (encoded !== null) {
        return base.concat(encoded);
      }
      return null;
    },
    get_detalle_image(image) {
      this.$store.dispatch('historicoObras/fetchImage', image)
        .then((result) => {
          const imagenes = {};
          Object.assign(imagenes, this.fetched_images);
          imagenes[image] = { data: this.decode_base64(result), loaded: true };
          this.fetched_images = imagenes;
          // context.fetched_images[image] = { data: context.decode_base64(result), loaded: true };
        });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          rowsPerPage,
          search: this.search,
          sortBy,
          descending,
        };
        this.$store.dispatch('historicoObras/fetchAccesos', formdata)
          .then(() => {
            this.loading = false;
            const items = this.$store.getters['historicoObras/accesos_list'];
            const total = this.$store.getters['historicoObras/accesos_total'];

            this.$store.commit('historicoObras/fetchedAccesos');
            resolve({
              items,
              total,
            });
          });
      });
    },
    is_admin() {
      if (getJWTData().user_claims.role === 'admin') {
        return true;
      }
      return false;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    fetchEventsList() {
      if (!this.$store.getters.loading_accesos) {
        this.$store.dispatch('historicoObras/clearAccesosAction');
        this.$store.dispatch('historicoObras/fetchAccesos');
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    detalles_acceso(val) {
      val.expanded = !val.expanded;
    },
    show_acceso_detalles(acceso, detalle) {
      this.fetched_images = {};
      this.acceso = acceso;
      this.detalle_acceso = detalle;
      this.dialogDetalles = true;
      detalle.personas.forEach((element) => {
        if (element.foto_rostro != null && element.foto_rostro !== '') {
          this.fetched_images[element.foto_rostro] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_rostro);
        }
        if (element.foto_credencial_frente != null && element.foto_credencial_frente !== '') {
          this.fetched_images[element.foto_credencial_frente] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_credencial_frente);
        }
        if (element.foto_credencial_trasera != null && element.foto_credencial_trasera !== '') {
          this.fetched_images[element.foto_credencial_trasera] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_credencial_trasera);
        }
      });
      detalle.vehiculos.forEach((element) => {
        if (element.foto_frontal != null && element.foto_frontal !== '') {
          this.fetched_images[element.foto_frontal] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_frontal);
        }
        if (element.foto_lateral != null && element.foto_lateral !== '') {
          this.fetched_images[element.foto_lateral] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_lateral);
        }
        if (element.foto_trasera != null && element.foto_trasera !== '') {
          this.fetched_images[element.foto_trasera] = {
            loaded: false,
            data: '',
          };
          this.get_detalle_image(element.foto_trasera);
        }
      });
    },
    close_dialog_detalles() {
      this.acceso = [];
      this.detalle_acceso = [];
      this.dialogDetalles = false;
      this.$store.commit('historicoObras/clearAccesosDetalles');
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      return moment(fecha, 'DD-MM-YYYY HH:mm:SS').format(formato);
    },
    formatter_time(hora, formato = 'HH:mm') {
      return moment(hora, 'HH:mm:ss').format(formato);
    },
    formatter_date_range(desde, hasta, formato = 'DD-MM-YYYY') {
      return `${this.formatter_date(desde, formato)} al ${this.formatter_date(hasta, formato)}`;
    },
    formatter_time_range(desde, hasta, formato = 'HH:mm') {
      return `${this.formatter_time(desde, formato)} a ${this.formatter_time(hasta, formato)}`;
    },
    formatter_dias_vigencia(acceso) {
      let html = '';
      if (acceso.lunes === true) {
        html += 'Lunes ';
      }
      if (acceso.martes === true) {
        html += 'Martes ';
      }
      if (acceso.miercoles === true) {
        html += 'Miércoles ';
      }
      if (acceso.jueves === true) {
        html += 'Jueves ';
      }
      if (acceso.viernes === true) {
        html += 'Viernes ';
      }
      if (acceso.sabado === true) {
        html += 'Sábado ';
      }
      if (acceso.domingo === true) {
        html += 'Domingo ';
      }
      return html;
    },
  },
};
</script>
